/* custom-marketplace-tracking.js (2026-06-22 追加)
 * 目的: 商品ページのモール送客リンク（Amazon / 楽天 / Yahoo!ショッピング / メルカリ）の
 *       クリックを GA4 イベント `marketplace_outbound_click` として送信する。
 * モデル化CV: モール購入は当方ピクセルが届かないため、1クリックの期待値
 *       value = 円価格 × RATE[marketplace]（既定 1% 想定）を value(JPY) として送る。
 *       → GA4 でキーイベント化 → Google 広告へ取り込み（当面 secondary / 観測専用）。
 * 依存: GA4 タグ(G-7MS3LL2J04) は本スクリプトが「初回モールクリック時に遅延読込」する
 *       （send_page_view:false・既存 _ga クッキー共有）。初期表示では読み込まず約176KB削減。
 *       ページ上に既に gtag.js があれば再利用し二重読込しない。
 *       商品情報は snippet が出力する window.__mpProduct から取得。(2026-06-24 性能改善)
 * 注意: モール出稿リンクは現状 templates/product.json の custom_liquid_hNU8LB（.mall-btn）のみ。
 *       将来 .mall-btn 以外で増えた場合は marketplaceFromAnchor() の判定を拡張すること。
 */
(function () {
  'use strict';

  var MEASUREMENT_ID = 'G-7MS3LL2J04';

  // Pinterest Conversions API リレー（Cloudflare Worker）の URL。(2026-08-13追加)
  // 中継先は自前の Worker で、Pinterest の専用トークンは Worker 側にだけ置く。
  var CAPI_ENDPOINT = 'https://pinterest-capi-relay.soft-credit-f496.workers.dev/';

  // ★ 「1%が購入につながる」想定はここ1箇所に集約。実モール売上(Amazon Attribution 等)で
  //    較正し、媒体別に調整する。0 にするとその媒体の value は 0 になる（件数は計上）。
  var RATE = { amazon: 0.01, rakuten: 0.01, yahoo: 0.01, mercari: 0.01 };

  function marketplaceFromAnchor(a) {
    var cls = ' ' + (a.className || '') + ' ';
    if (cls.indexOf(' mall-amazon ') > -1) return 'amazon';
    if (cls.indexOf(' mall-rakuten ') > -1) return 'rakuten';
    if (cls.indexOf(' mall-yahoo ') > -1) return 'yahoo';
    if (cls.indexOf(' mall-mercari ') > -1) return 'mercari';
    // フォールバック: ホスト名で判定（class が変わっても拾えるように）
    var host = '';
    try { host = new URL(a.href).hostname; } catch (e) { return null; }
    if (host.indexOf('amazon.') > -1) return 'amazon';
    if (host.indexOf('rakuten') > -1) return 'rakuten';
    if (host.indexOf('yahoo') > -1) return 'yahoo';
    if (host.indexOf('mercari') > -1) return 'mercari';
    return null;
  }

  function expectedYenValue(marketplace) {
    var raw = (window.__mpProduct && window.__mpProduct.price_yen) || 0;
    // price_yen は "1500" 形式（money_without_currency | remove: ','）。小数や記号は除去。
    var yen = parseFloat(String(raw).replace(/[^0-9.]/g, '')) || 0;
    var rate = (RATE[marketplace] != null) ? RATE[marketplace] : 0;
    return Math.round(yen * rate);
  }

  var lastSentAt = 0; // 同一クリックの click / auxclick 二重発火ガード

  // --- Pinterest Conversions API 連携 (2026-08-13追加) --------------------
  // モールクリックを Pinterest の lead イベントとして中継 Worker へ送る。
  // GTM を撤去した 2026-06-18 以降 Lead が受信ゼロになっていたのを、テーマから
  // 直接ではなくクリック時のみサーバー経由で送る形で復旧する（専用トークンは
  // ブラウザに置けないため、リレーを挟む）。
  function newEventId() {
    var rand = Math.random().toString(36).slice(2, 10);
    return 'mp-' + Date.now() + '-' + rand;
  }

  function sendCapiLead(marketplace, prod, value, linkUrl) {
    if (CAPI_ENDPOINT.indexOf('REPLACE_AFTER_DEPLOY') > -1) return; // 未デプロイ
    if (!navigator.sendBeacon) return;
    var body = JSON.stringify({
      event_name: 'lead',
      event_id: newEventId(),
      marketplace: marketplace,
      item_id: (prod.id != null) ? String(prod.id) : '',
      item_name: prod.title || '',
      value: value,
      event_source_url: location.href
    });
    try {
      // Content-Type は text/plain にする。application/json にすると CORS の
      // プリフライトが要るが、sendBeacon はプリフライトを行えず送信が落ちる。
      // Worker 側は Content-Type に依存せず本文を JSON として読む。
      var queued = navigator.sendBeacon(CAPI_ENDPOINT, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      // sendBeacon はキューに積めないと false を返す（送信は行われない）。
      // その場合だけ keepalive 付きの fetch へ落とす。fetch も遷移をブロックしない。
      if (!queued && typeof fetch === 'function') {
        fetch(CAPI_ENDPOINT, {
          method: 'POST',
          body: body,
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          keepalive: true,
          mode: 'cors'
        })['catch'](function () {});
      }
    } catch (e) {
      // 送れなくてもモールへの遷移を妨げない
    }
  }

  // gtag.js がページ上に既に存在するか（チャネル/Web Pixels が読込済みなら再利用）
  function gtagLibPresent() {
    var scripts = document.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; i++) {
      if ((scripts[i].src || '').indexOf('googletagmanager.com/gtag/js') > -1) return true;
    }
    return false;
  }

  // 初回モールクリック時のみ gtag を遅延読込/設定（未ロード時のみ実際に読み込む）
  var configured = false;
  function ensureGtag() {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
    }
    if (!gtagLibPresent()) {
      var s = document.createElement('script');
      s.async = true;
      s.src = 'https://www.googletagmanager.com/gtag/js?id=' + MEASUREMENT_ID;
      document.head.appendChild(s);
    }
    if (!configured) {
      configured = true;
      window.gtag('config', MEASUREMENT_ID, { send_page_view: false });
    }
  }

  function onClick(e) {
    var a = (e.target && e.target.closest) ? e.target.closest('a[href]') : null;
    if (!a) return;
    var marketplace = marketplaceFromAnchor(a);
    if (!marketplace) return;

    var now = (typeof Date.now === 'function') ? Date.now() : (+new Date());
    if (now - lastSentAt < 500) return;
    lastSentAt = now;

    var prod = window.__mpProduct || {};
    var yenValue = expectedYenValue(marketplace);

    // Pinterest へは gtag の読込を待たずに送る（GA4 が落ちても Lead は届く）
    sendCapiLead(marketplace, prod, yenValue, a.href);

    ensureGtag(); // 初回クリック時に gtag を遅延読込/設定（未ロード時のみ実読込）
    if (typeof window.gtag !== 'function') return; // 念のため（送れない場合は送らない）

    window.gtag('event', 'marketplace_outbound_click', {
      marketplace: marketplace,
      item_id: (prod.id != null) ? String(prod.id) : '',
      item_name: prod.title || '',
      link_url: a.href,
      value: yenValue,
      currency: 'JPY',
      send_to: MEASUREMENT_ID
    });
  }

  // 委譲リスナ（capture）。target=_blank でページが残るため beacon 送信は確実。
  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true); // 中クリック等
})();
